<template>
  <div v-if="automation">
    <popup-add-action ref="popupAddAction" />
    <popup-duplicate-automation ref="popupDuplicateAutomation" />
    <vx-card no-shadow>
      <vs-breadcrumb class="mt-2">
        <li>
          <router-link to="/crm/automations"> Automations</router-link
          ><span class="vs-breadcrum--separator">/</span>
        </li>
        <li aria-current="page" class="active">Edit automation</li>
      </vs-breadcrumb>

      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-2/5 w-full">
          <h2>Automation</h2>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Enabled</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-switch v-model="automation.enabled" />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Automation name</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input
            label=""
            :content.sync="automation.name"
            v-model="automation.name"
            class="w-full"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Category</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-input
            label=""
            :content.sync="automation.category"
            v-model="automation.category"
            class="w-full"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Limit to venue(s)</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-switch v-model="automation.limitVenues" />
        </div>
      </div>

      <div class="vx-row mb-6" v-if="automation.limitVenues">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Venues</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <venue-selector
            v-model="automation.venues"
            :globalMode="true"
            :multiple="true"
          />
          <p>
            Automation only runs when the event happens on any of the selected
            venues.
          </p>
        </div>
      </div>

      <!--<div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Trigger</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-select
            class="selectExample"
            label="Trigger type"
            v-model="automation.triggerType"
          >
            <vs-select-item
              :key="index"
              :value="index"
              :text="item"
              v-for="(item, index) in triggerTypes"
            />
          </vs-select>
        </div>
      </div>-->

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <!--<span>If</span>-->
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <div class="ifttt">
            <span class="ifttt-text mr-3">When</span>
            <!--<vs-button
              class="btnx cursor-default"
              color="success"
              type="filled"
              >{{ triggerTypes[automation.triggerType] }}</vs-button>-->

            <vs-dropdown class="cursor-pointer" :vs-trigger-click="true">
              <!--<vs-button
                color="success"
                class="btn-drop cursor-pointer"
                type="filled"
                icon="expand_more"
              ></vs-button>-->
              <div
                class="p-4 bg-success filled rounded-full flex items-center justify-between"
              >
                <span class="mr-2">{{
                  triggerTypes[automation.triggerType]
                }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>

              <vs-dropdown-menu>
                <vs-dropdown-item
                  @click="changeTrigger(item.index)"
                  :key="item.index"
                  v-for="item in triggerTypesWithIndex"
                >
                  {{ item.type }}
                </vs-dropdown-item>
                <!--<vs-dropdown-group>
                  <vs-dropdown-item> option 1 </vs-dropdown-item>
                  <vs-dropdown-item> option 2 </vs-dropdown-item>
                </vs-dropdown-group>-->
                <!-- <vs-dropdown-item divider> option 3 </vs-dropdown-item>-->
              </vs-dropdown-menu>
            </vs-dropdown>
            <span class="ifttt-text ml-3">Then:</span>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <!--<span>Actions</span>-->
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <div class="vx-col w-full mb-base">
            <vx-card>
              <!-- title="Actions"-->
              <action-timeline
                :automation="automation"
                :allowNewAction="true"
              />
            </vx-card>
          </div>
        </div>
      </div>

      <!-- Save & Remove Button -->
      <vs-row
        vs-justify="space-between"
        class="flex flex-wrap items-center"
        style="margin-top: 32px"
      >
        <div>
          <vs-button
            id="remove-button"
            @click="confirmRemove"
            v-if="hasPermission('vp.crm.automations.edit')"
            color="danger"
            class="mt-2"
            >Remove</vs-button
          >
          <vs-button
            id="warning-button"
            @click="$refs.popupDuplicateAutomation.show()"
            v-if="hasPermission('vp.crm.automations.edit')"
            color="warning"
            class="mt-2 ml-3"
            >Duplicate</vs-button
          >
        </div>

        <vs-button
          id="save-button"
          v-if="hasPermission('vp.crm.automations.edit')"
          @click="update"
          class="mt-2"
          >Save Changes</vs-button
        >
      </vs-row>
    </vx-card>

    <vx-card no-shadow> </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import PopupAddAction from "./Actions/popupAddAction.vue";
import PopupDuplicateAutomation from "./PopupDuplicateAutomation.vue";
import VenueSelector from "@/components/VenueSelector.vue";
import ActionTimeline from "./Actions/ActionTimeline";
export default {
  components: {
    PopupAddAction,
    ActionTimeline,
    VenueSelector,
    PopupDuplicateAutomation,
  },
  props: {},
  data() {
    return {
      automationId: "",
    };
  },
  methods: {
    changeTrigger(idx) {
      this.automation.triggerType = idx;
    },
    async update() {
      this.$vs.loading();
      await this.$store.dispatch("automations/update", this.automation);
      this.$vs.loading.close();
    },
    async confirmRemove() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to delete this automation?",
        accept: this.remove,
      });
    },
    async remove() {
      this.$vs.loading();
      await this.$store.dispatch("automations/delete", this.automationId);
      this.$vs.loading.close();
      this.$router.go(-1);
    },
  },
  computed: {
    ...mapGetters({
      triggerTypes: "automations/triggerTypes",
      triggerTypesWithIndex: "automations/triggerTypesWithIndex",
      actionToIconMap: "automations/actionToIconMap",
      automation: "automations/automation",
    }),
  },
  async created() {
    this.automationId = this.$route.params.id;
    await this.$store.dispatch("automations/get", this.automationId);
    console.log("Automation?", this.automation);
  },
};
</script>


<style lang="scss">
@font-face {
  font-family: "HelNeue";
  src: url("/layouts/components/vertical-nav-menu/fonts/Helvetica-Neue-Condensed-Bold.woff")
      format("woff"),
    /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
      url("/layouts/components/vertical-nav-menu/fonts/Helvetica-Neue-Condensed-Bold.ttf")
      format("truetype"); /* Chrome 4+, Firefox 3.5, Opera 10+, Safari 3—5 */
}
.ifttt {
  display: flex;
  align-items: center;
  /*justify-content: center;*/

  .ifttt-text {
    font-size: 1.4em;
    font-family: HelNeue;
  }

  button {
    margin: 0px !important;

    &.btnx {
      margin-left: 10px !important;
      border-radius: 5px 0px 0px 5px;
    }

    &.btn-drop {
      border-radius: 0px 5px 5px 0px;
      border-left: 1px solid rgba(255, 255, 255, 0.2);
    }
  }
}
</style>